export const reportRoutes = [
  {
    path: "/report/pdf",
    component: () => import("@/views/Report/PDFReport.vue"),
  },
  {
    path: "/report/donation-transactions",
    component: () => import("@/views/Report/DonationTransactionsReport.vue"),
  },
  {
    path: "/report/school-donors-report",
    component: () => import("@/views/Report/SchoolDonorsReport.vue"),
  },
  {
    path: "/report/participating-schools-report",
    component: () => import("@/views/Report/ParticipatingSchoolsReport.vue"),
  },
  {
    path: "/report/school-funding-request-detail-report",
    component: () =>
      import("@/views/Report/SchoolFundingRequestDetailReport.vue"),
  },
  {
    path: "/report/school-funding-request-summary-report",
    component: () =>
      import("@/views/Report/SchoolFundingRequestSummaryReport.vue"),
  },
  {
    path: "/report/school-officers-report",
    component: () => import("@/views/Report/SchoolOfficersReport.vue"),
  },
];
